import React from "react";
import { GiftIcon, ArrowRightIcon } from "lucide-react";
import { bonuses } from "../data/bonuses";
import { images } from "../data/images";
import { CtaButton } from "./CtaButton";
import { useLocalizedPrices } from "../hooks/useLocalizedPrices";
export function BonusesSection() {
  const {
    mainPrice,
    bonusPrices,
    bonusesTotal
  } = useLocalizedPrices();
  return <section id="bonos" className="bg-cocoa-900 py-14 text-cream-100 sm:py-28" data-id="element-19" data-mp="14tkr97q2b5vr">
      <div className="mx-auto max-w-6xl px-5" data-id="element-20" data-mp="14rhrvx30s0ed">
        <div className="grid gap-8 lg:grid-cols-[1fr_1fr] lg:items-center lg:gap-16" data-id="element-21" data-mp="zv9h0vvuutd0">
          <div className="text-center lg:text-left" data-id="element-22" data-mp="1ej4867u7spnz">
            <p className="inline-flex items-center gap-2 font-display text-xl italic text-caramel-300" data-id="element-23" data-mp="1eim44p1b975i">
              <GiftIcon className="h-5 w-5" aria-hidden="true" data-id="element-24" data-mp="19mdvzvlj6e7u" />
              Siempre incluidos
            </p>
            <h2 className="mt-3 font-display text-4xl font-semibold leading-tight text-cream-50 sm:text-5xl" data-id="element-25" data-mp="1nhpp5yk1fwmn">
              4 bonos estratégicos para que no empieces con la hoja en blanco
            </h2>
            <p className="mt-5 text-lg leading-relaxed text-cream-200" data-id="element-26" data-mp="3psoe7xpkrnie">
              Los volúmenes te explican qué hacer. Los bonos te dan las herramientas para hacerlo hoy mismo.
            </p>
          </div>
          <img src={images.cookies} alt="Cookies con chips de chocolate recién horneadas" className="aspect-[16/10] w-full rounded-2xl object-cover" data-id="element-27" data-mp="7kfjmwn2i7lq" />
        </div>

        <ul className="mt-10 grid gap-4 sm:mt-14 sm:grid-cols-2 sm:gap-5" data-id="element-28" data-mp="gkvifssv8qk9">
          {bonuses.map((b, i) => {
          const Icon = b.icon;
          return <li key={b.title} className="flex flex-col rounded-2xl border-2 border-caramel-500/70 bg-cocoa-950 p-6 sm:p-8" data-id="element-29" data-mp="legal47s2qbj" data-mpi={i}>
                <div className="flex items-start justify-between" data-id="element-30" data-mp="vbumqrmo4sy1">
                  <span className="font-display text-5xl font-semibold leading-none text-caramel-400 sm:text-6xl" data-id="element-31" data-mp="108l19aitrghc">
                    {String(i + 1).padStart(2, "0")}
                  </span>
                  <span className="flex h-11 w-11 items-center justify-center rounded-full bg-caramel-500/15 text-caramel-300" data-id="element-32" data-mp="5mxdypyenqx5">
                    <Icon className="h-5 w-5" aria-hidden="true" data-id="element-33" data-mp="kclg1teeutlx" />
                  </span>
                </div>
                <p className="mt-4 inline-flex items-center gap-1.5 text-xs font-bold uppercase tracking-wider text-caramel-300" data-id="element-34" data-mp="fj0rerypjbze">
                  <GiftIcon className="h-3.5 w-3.5" aria-hidden="true" data-id="element-35" data-mp="ocnii4ryzr29" />
                  Bono {i + 1}
                </p>
                <h3 className="mt-2 font-display text-2xl font-semibold leading-snug text-cream-50" data-id="element-36" data-mp="13a65p2p01w7l">{b.title}</h3>
                <p className="mt-2 leading-relaxed text-cream-200" data-id="element-37" data-mp="ybuw8t2m9npw">{b.text}</p>

                <div className="mt-auto flex items-center gap-3 pt-6" data-id="element-38" data-mp="350rca95zjs9o">
                  <span className="text-lg text-cream-300 line-through decoration-cream-300/80" aria-label={`Valor de referencia ${bonusPrices[i]}`} data-id="element-39" data-mp="3026ai5b350j4">
                    {bonusPrices[i]}
                  </span>
                  <span className="rounded-full bg-caramel-500 px-4 py-1.5 text-sm font-bold uppercase tracking-wide text-cocoa-950" data-id="element-40" data-mp="1kiyzw74s3yu5">
                    Gratis
                  </span>
                </div>
              </li>;
        })}
        </ul>

        <div className="mt-5 rounded-2xl border-2 border-caramel-500 bg-cocoa-950 px-6 py-7 text-center sm:px-10 sm:py-9" data-id="element-41" data-mp="1arkvbkxz08u5">
          <p className="text-xs font-bold uppercase tracking-[0.18em] text-caramel-300" data-id="element-42" data-mp="10v9dkffm2qsb">Valor total de los bonos</p>
          <div className="mt-3 flex flex-col items-center justify-center gap-2 sm:flex-row sm:gap-4" data-id="element-43" data-mp="mvq9bxpx7zla">
            <span className="font-display text-3xl text-cream-300 line-through decoration-cream-300/80 sm:text-4xl" data-id="element-44" data-mp="ru1f9xd3hpy8">
              <span className="sr-only" data-id="element-45" data-mp="2haj09jfv026w">Valor de referencia </span>{bonusesTotal}
            </span>
            <ArrowRightIcon className="hidden h-6 w-6 text-caramel-400 sm:block" aria-hidden="true" data-id="element-46" data-mp="2m7j6pvgmf6yj" />
            <span className="font-display text-3xl font-semibold text-caramel-400 sm:text-4xl" data-id="element-47" data-mp="m59xwb5f9ah6">
              Gratis con tu colección
            </span>
          </div>
          <p className="mt-3 text-sm text-cream-200" data-id="element-48" data-mp="d5ehnrx0epaa">Incluidos en tu compra de {mainPrice}, pago único.</p>
          <div className="mt-6 flex justify-center" data-id="element-49" data-mp="8735haj8s2ow">
            <CtaButton label="Quiero acceder al pack completo" data-id="element-50" data-mp="86aa15pqgzm2" />
          </div>
        </div>
      </div>
    </section>;
}